import { render, staticRenderFns } from "./EnviarCodigoSeguranca.vue?vue&type=template&id=750b9c36&"
import script from "./EnviarCodigoSeguranca.vue?vue&type=script&lang=js&"
export * from "./EnviarCodigoSeguranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports